import { OrderAssistProviderOption, SelectOption, WriteBackProvider } from '../types';
import addressFormat from './addressFormatter';
import { getSelectedItemAddress } from './search/getSelectedAddress';

export const parseOptionToWritebackProvider = (
  option: OrderAssistProviderOption,
  ehrSpecialty: SelectOption | undefined,
): WriteBackProvider => {
  const { details } = option;
  const address = getSelectedItemAddress(option);
  const specialties = ehrSpecialty
    ? [{ id: ehrSpecialty.value, description: ehrSpecialty.label }]
    : details.specialties ?? [];

  const provider = {
    npi: details.npi,
    specialty: specialties,
    demographics: {
      firstName: details.complexName.firstName,
      lastName: details.complexName.lastName,
    },
    organizations: [
      {
        name: details.acoName || address?.officeName || '',
        address: address
          ? {
              ...address,
              fullAddress: addressFormat(address),
            }
          : { zipCode: '' },
        contact_info: {
          mobilePhoneNumber: address?.phone,
          faxNumber: address?.fax,
        },
      },
    ],
  };
  return provider;
};
